module.exports = __webpack_public_path__ + "static/media/fourteenth_the_inn4.86a2cec3.png";